export default "__VITE_ASSET__m$JXP00O__"